import React from "react";

const ProblemBeneathTheSurface = () => {
  return (
    <div className="about_area aws-challenge">
      <div className="container">
        <div className="row">
             <div className="section_main_title mb-3">
                <h3>The Problem Beneath the Surface</h3>
              
              </div>
         <div className="col-lg-6 col-md-6 col-sm-12 col-xs-6">
           
            <div className="singel_about_left text-left">
              
              <div className="singel_about_left_inner d-flex align-items-center">
                <div className="about_icon mr-3">
                  
                </div>
                
              </div>
              <div className="singel_about_left_inner d-flex align-items-center">
                <div className="about_icon mr-3">
                
                </div>
                <div className="singel-about-content">
                 
                  <p>
                  ● No enterprise-wide view of upcoming technology renewal cycles across key accounts. <br/> ● Resource allocation decisions were made without visibility into installed tech, with detection dates or contract maturity. <br/> ● Regional teams were unable to anticipate competitive displacement or churn windows. <br/> ● Market engagement strategies were misaligned with the actual technology landscape.

                  </p>
                </div>
              </div>
             
             
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12 col-xs-6">
           
            <div className="singel_about_left mb-30 text-left">
              <div className="singel_about_left_inner d-flex align-items-center">
                <div className="about_icon mr-3">
                 
                </div>
                <div className="singel-about-content">
                  
                  <p>
                 ● Time-sensitive detection insights were missing, undermining timely and relevant outreach.
 <br/>  ● Legacy technology adoption patterns in emerging regions remained largely uncharted. <br/>● Growth initiatives missed critical buying signals tied to upgrade or replacement intent.
 <br/>● Strategic engagement often occurred too late, typically after renewal decisions had already been made.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProblemBeneathTheSurface;
